module.exports = __webpack_public_path__ + "img/37.24fca42b.png";